const ALLOWED_FORMATTING_ELEMENTS = new Set(["B", "EM", "I"]);
const REMOVED_ELEMENTS = new Set(["SCRIPT", "STYLE", "TEMPLATE"]);

/** Keeps notification content as text with attribute-free bold and italic formatting only. */
export function sanitizeNotificationHtml(content: string): string {
  const parsedDocument = new DOMParser().parseFromString(content, "text/html");
  const elements = Array.from(parsedDocument.body.querySelectorAll("*")).reverse();

  for (const element of elements) {
    if (REMOVED_ELEMENTS.has(element.tagName)) {
      element.remove();
    } else if (ALLOWED_FORMATTING_ELEMENTS.has(element.tagName)) {
      for (const attribute of Array.from(element.attributes)) {
        element.removeAttribute(attribute.name);
      }
    } else {
      element.replaceWith(...element.childNodes);
    }
  }

  return parsedDocument.body.innerHTML;
}
